'use strict';

var Link = require('../Link');
var getUserData = require('../../models/user-urls');

function renderUserLinks(depsArg) {
	var userData = getUserData.getUserData(depsArg);
	var _ = depsArg.underscore;
	var user,
		roles,
		channel;

	function getCapabilities(config) {
		user = config.UserInfo || {};
		roles = user.roles || [];
		channel = config.CHANNEL_SETTINGS || {};
	}

	return {
		renderSubscriptionLink: function(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'My.Subscription',
				urlSource: userData.getSubscriptionUrl(),
				isVisible: channel.accountEdition && _.contains(roles, 'CHANNEL_ADMIN')
			})).render(config, deps);
		},

		renderCompanyLink: function render(config, deps) {
			return (new Link({
				labelRaw: 'My.Company',
				urlSource: userData.getCompanyUrl(config),
				isVisible: config.CHANNEL_SETTINGS.showProfiles
			})).render(config, deps);
		},

		renderProfileLink: function render(config, deps) {
			return (new Link({
				labelRaw: 'My.Profile',
				urlSource: userData.getProfileUrl(config),
				isVisible: config.CHANNEL_SETTINGS.showProfiles
			})).render(config, deps);
		},

		renderSettingsLink: function render(config, deps) {
			return (new Link({
				labelRaw: 'my.settings',
				urlSource: userData.getSettingsUrl(config),
				isVisible: !config.CHANNEL_SETTINGS.identityProvider
			})).render(config, deps);
		},

		renderMobileSwitchLink: function render(config, deps) {
			function getMobileSwitchLabel() {
				return config.isAdMobileWebApp
					? 'Go.to.Desktop.Site'
					: 'Go.to.Mobile.Site';
			}

			var displayMobileLink = (
				deps && deps.shouldDisplayGoToMobileLink
			) || function() { return false; };

			var link = (new Link({
				labelRaw: getMobileSwitchLabel(),
				isVisible: config.isAdMobileWebApp || displayMobileLink(),
				urlSource: userData.getMobileSwitchUrl(config)
			})).render(config, deps);

			return link;
		}
	};
}

module.exports = {
	renderUserLinks: renderUserLinks
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/links/user-links.js
// module id = 12
// module chunks = 0